<template>
    <modal title="手机验证" :show=show :onCancel=onCancel :onSure=onSure height='196'>
         <div class="check-phone" slot="content">
             <p class="tip">提示：为了您的账号安全重要操作时，请进行短信验证</p>
             <div class=""><label>绑定手机:</label><span class="phone">{{mobile}}</span><span class="unless" @click="toapeal">手机号换了，无法验证？</span></div>
             <div class="item"><label class="lbname">验证码:</label>
                <div class="code-box">
            <input type="text" v-model.trim="code" maxlength="10" placeholder="输入验证码" ><span class="send-btn" @click="sendcode(0)" v-if=!time>发送验证码</span><span class="send-btn disabled" v-else>({{time}}s)重新获取</span><span class="times" v-if="times!=''">剩余{{times}}次</span>
                <p class="error-info">{{errorTip}}</p>
                <p>收不到验证码？ 试试<span class="voice-btn" @click="sendcode(1)">语音验证码</span></p>
                </div>
             </div>
         </div>
     </modal>
</template>
<script>
import { getSecurity } from '@/service/settingService'
import { getUserInfo } from '@/service/homeService'
import router from '@/router'
import utils  from '@/common/utils'
// import { mapState } from 'vuex'
export default {
    name: 'checkphone',
    data() {
        return {
            times:'',
            code:'',
            time:'',
            errorTip:'',
            show:true,
            timer:null,
            mobile:''
        }
    },
    created(){
        getUserInfo().then(res=>{
            this.mobile=res.mobile
        })
    },
    // computed:{
    //      ...mapState([
    //         'baseSet'
    //     ]),
    // },
    beforeDestroy(){
        this.timer&&clearInterval(this.timer)
    },
    watch:{
        code:function(){
            this.errorTip=''
        }
    },
    methods:{
        toapeal(){
            this.show=false            
            router.push({name:'appeal',query:{step:1}})
        },
        onCancel(){
            this.show=false
        },
        sendcode(type){
            if(this.time){
                return
            }
            getSecurity(type).then(res=>{
                if(res.status==200){
                    this.times=res.data
                    utils.countdown.call(this,{
                        time:60,
                        computedTime:'time',
                        timer:this.timer
                    })
                }else if(res.status==412||res.status==406){
                    this.errorTip='验证码发送频繁'                        
                }else{
                    this.errorTip='验证码发送失败'                                            
                }
            })
        },
        onSure(){
            let code=this.code
            if(!code){
                this.errorTip='验证码不能为空'
                return 
            }
            if(this.cb){
                this.cb(this.code).then(res=>{
                    if(res.status==409){
                        this.errorTip='验证码错误'
                    }else{
                        this.show=false
                    }
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.check-phone{
    text-align: left;
    padding:0 50px;
    font-size: 12px;
    .tip{
        color:#84848B;
        margin:22px 0 18px;
    }
    label{
        color:#333333;
    }
    input{
        width:120px;
        height:32px;
        border:1px solid #B8B8B8;
        color:#84848B;
        padding: 10px;
        &:hover{
            border:1px solid #505060;
            color:#434354;
        }
    }
    .item{
        margin-top:21px;
    }
    .lbname{
        display: inline-block;
        line-height: 32px;
    }
    .code-box{
        display: inline-block;
        vertical-align: top;
        margin-left:14px;        
    }
    .error-info{
        font-size: 12px;
        color: #CC0000;
        text-align:left;
        margin:6px 0 10px;  
        height: 12px;          
    }
    .phone{
        color:#323237;
        margin:0 14px;
    }
    .unless{
        color:#D59334;
        cursor: pointer;
    }
    .send-btn{
        display: inline-block;
        width:90px;
        height:32px;
        line-height:32px;        
        border:1px solid #D19F4E;
        color:#D19F4E;
        text-align: center;
        margin:0 10px;
        cursor: pointer;
        &.disabled{
            border:1px solid #BABABA;
            color:#BABABA;
            background: #F9F9F9;
            cursor: default;
        }
    }
    .times{
        color:#84848B;
        display: inline-block;
        vertical-align: bottom;
    }
    .voice-btn{
        color:#D19F4E;
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/checkphone.vue